import React from 'react';
import { makeStyles } from '@mui/styles';
import clsx from 'clsx';

import { View, Text } from '../../../Base';
import { formatSecondsToHHMM } from '../../../../utils/date';
import { PreciseIcon, WarningIcon } from '../../../icons';
import palette from '../../../styles/palette';

const useStyles = makeStyles(() => ({
  container: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  text: {
    fontSize: '0.75rem',
    lineHeight: '1rem',
    color: 'white',
    flexDirection: 'row',
    display: 'flex',
  },
  icon: {
    width: '0.75rem',
    height: '0.75rem',
    marginLeft: '0.125rem',
    display: 'flex',
    alignItems: 'center',

    '& svg': {
      width: '0.75rem',
      height: '0.75rem',
    },
  },
  iconGreen: {
    '& svg': {
      fill: 'green',
    },
  },
  iconGrey: {
    '& svg': {
      fill: palette.typography.white.medium,
    },
  },
}));

const OpportunityIcon = (value) => {
  const styles = useStyles();
  if (value > 0) {
    return (
      <View className={clsx(styles.icon, styles.iconGreen)}>
        <PreciseIcon />
      </View>
    );
  } else if (value < 0) {
    return (
      <View className={styles.icon}>
        <WarningIcon />
      </View>
    );
  } else {
    return (
      <View className={clsx(styles.icon, styles.iconGrey)}>
        <PreciseIcon />
      </View>
    );
  }
};

const OpportunityTime = ({ value }) => {
  const styles = useStyles();
  return (
    <View className={styles.container}>
      <Text className={styles.text} data-testid="opportunity-time">
        {formatSecondsToHHMM(value)}
      </Text>
      <OpportunityIcon value={value} />
    </View>
  );
};

export default OpportunityTime;
